import axios from 'axios';

import { handleError } from '../../../network/servicErrorHandling';
import config from '../../../settings/config';
import { isSiteDomain } from '../../../settings/domainManager';

axios.defaults.headers.common["Authorization"] = localStorage.getItem(
  `${window.location.hostname}_token`
);

async function getUserShopOrders(uid, next, searchKey) {
  return Promise.resolve().then((v) =>
    axios
      .get(
        next
          ? next.replace("http:", "https:")
          : `${config.baseUrl}v1/users/current/orders?q=${searchKey}&shop=${
              isSiteDomain ? "domain" : uid
            }`
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        handleError(err);
      })
  );
}

export { getUserShopOrders };
